import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fructidor/fructidor-ui/releases/20250425155230/app/[lng]/(home)/sales-listing/(components)/SalesOfferPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","getState"] */ "/opt/fructidor/fructidor-ui/releases/20250425155230/app/globalRedux/store.ts");
